// extracted by mini-css-extract-plugin
module.exports = {"wizardStepContent":"WizardStepContent_wizardStepContent__kF0AQ","header":"WizardStepContent_header__1wp1P"};